import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UploadFiles_uploadFiles_uploadedFiles as UploadFilesFileGenerated,
  UploadFiles as UploadFilesGenerated,
  UploadFilesVariables as UploadFilesVariablesGenerated,
} from "core/queries/__generated__/UploadFiles";

export interface UploadFilesResponse extends UploadFilesGenerated {}
export interface UploadFilesVariables extends UploadFilesVariablesGenerated {}
export interface UploadFilesFile extends UploadFilesFileGenerated {}

export const uploadFiles = gql`
  mutation UploadFiles(
    $files: [Upload!]
    $attachableId: ID!
    $attachableType: FilesAttachable!
  ) {
    uploadFiles(
      files: $files
      attachableId: $attachableId
      attachableType: $attachableType
    ) {
      errors
      success
      uploadedFiles {
        id
        url
        format
        publicId
        attachableType
        attachableId
      }
    }
  }
`;

interface UseUploadFilesOptions {
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: UploadFilesResponse) => void;
  refetchQueries?: string[];
}
export const useUploadFiles = ({
  awaitRefetchQueries = false,
  onCompleted,
  refetchQueries = [],
}: UseUploadFilesOptions) =>
  useMutation<UploadFilesResponse, UploadFilesVariables>(uploadFiles, {
    awaitRefetchQueries,
    onCompleted,
    refetchQueries,
  });
